import { createContext, useContext } from 'react';

// Papel do usuário autenticado no painel admin.
// - 'admin'  → acesso total
// - 'viewer' → gestor de tráfego: leitura de Dashboard/Funil/Campanhas + Conversas read-only
// - null     → não autenticado (não deve ocorrer dentro do AdminGate)
export type AdminRole = 'admin' | 'viewer' | null;

export const AdminRoleContext = createContext<AdminRole>(null);

export function useAdminRole(): AdminRole {
  return useContext(AdminRoleContext);
}
